import styled from '@emotion/styled';
import React from 'react';

interface Props {
  className?: string;
}

export const LayoutMiddle: React.FC<React.PropsWithChildren<Props>> = ({ className, children }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

const Wrapper = styled.div`
  position: relative;
  vertical-align: top;
  top: 50%;
  transform: translateY(-50%);
`;
